import React, { useState, useEffect } from "react";
import axios, {AxiosError} from "axios";
import { CustomWebcam } from "./CustomWebcam"

type callbackType = () => any;
export function ImageUploader({ setImageKeys, folder, clearCallback }: { setImageKeys: React.Dispatch<React.SetStateAction<string[]>>, folder: string, clearCallback: callbackType }) {
  const [displayImgSrc, setDisplayImgSrc] = useState<string | null>(null);
  const [isDisplayFromCamera, setIsDisplayFromCamera] = useState<boolean>(false);
  const [cameraImgSrc, setCameraImgSrc] = useState<string | null>(null);
  const [errorMsg, setErrorMsg] = useState<string>("")
  const [resultMsg, setResultMsg] = useState<string>("")
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [isUploadInFlight, setIsUploadInFlight] = useState<boolean>(false);
  useEffect(() => {
    setDisplayImgSrc(cameraImgSrc)
    setIsDisplayFromCamera(true)
    setIsFilterApplied(false);
  }, [cameraImgSrc])

  const handleImageUplaod = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files == null) return

    console.log(`upload file size: ${e.target.files[0].size / 1024}MB`)
    if (e.target.files[0].size / 1024 > 2048) {
      window.alert("Please upload a photo less than 2MB.")
      e.target.files = null
      return
    }

    setDisplayImgSrc(URL.createObjectURL(e.target.files[0]))
    setIsDisplayFromCamera(false)
    setIsFilterApplied(false);
  }

  const clearAll = () => {
    clearCallback();
    setDisplayImgSrc(null);
    setIsDisplayFromCamera(false);
    setCameraImgSrc(null);
    setErrorMsg('');
    setIsFilterApplied(false);
  }

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    // prevent the page from reloading
    e.preventDefault();
    setIsUploadInFlight(true);
    setErrorMsg('');

    // construct form data
    const formData = new FormData(e.currentTarget);
    if (isDisplayFromCamera && cameraImgSrc !== null) formData.append('ss', encodeURIComponent(cameraImgSrc))
    formData.append('folder', folder)

    // make a POST request with Axios
    const res = await axios.post('https://api.photos.lscoba.com/reference', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).catch((err: Error | AxiosError) => {
      setIsFilterApplied(false);
      setIsUploadInFlight(false);
      if (!axios.isAxiosError(err)) {
        return console.error(err)
      } else if (err.response) {
        // The request was made and the server responded with a non-200 status code
        const msgmatch = (err.response.data as string).match(/\[([a-zA-Z0-9]+)\] ([a-zA-Z0-9]+): (.*)$/)
        if (msgmatch == null || msgmatch.length < 4) {
          setErrorMsg("Internal Server Error, Please contact admin (e1bf1299)")
          return
        }
        const [raw, reqid, exception, msg, ...rest] = msgmatch
        setErrorMsg(`${msg} (${reqid})`)
        return console.error(raw)
      } else if (err.request) {
        // The request was made but no response was received
        setErrorMsg("An error has occurred. No response was received.")
        return console.error(err.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        setErrorMsg("Internal Server Error, Please contact admin (5b92ebed)")
        return console.error(err.message)
      }
    });

    setIsUploadInFlight(false);

    if (!(res instanceof Object)) {
      // terminate all catched errors
      return
    }

    setImageKeys((res.data as string).split(";"))

    setIsFilterApplied(true);
    setResultMsg('Matched pictures are displayed below.')
  };

  return (
    <form onSubmit={handleFormSubmit} encType="multipart/form-data">
      <input type="file" name="image" id="file-upload" onClick={e => (e.target as HTMLInputElement).value = ''} onChange={handleImageUplaod} accept="image/*" alt="" />
      <div className="upload-outer-container">
        {displayImgSrc === null &&
          <>
            <p>Experience our new <i>face matching</i> feature!</p>
            <p>Capture or upload a photo of yourself, and the gallery will display only your photos.</p>
            <div className="disclaimer" style={{
              fontSize: "12px",
              textAlign: "right"
            }}>
              <p>Uploaded images will not be stored on our server.</p>
              <p>Our server is in-house developed and not maintained by third party.</p>
              <p>AI-generated filter results may not be 100% accurate. Please use at your discretion. </p>
            </div>
            <div className="picker-container">
              <CustomWebcam setImgSrc={setCameraImgSrc} />
              <span>or </span>


              <label htmlFor="file-upload" className="custom-file-upload">
                <i className="fa fa-cloud-upload"></i> Upload a picture
              </label>

              
            </div>
          </>
        }
        {displayImgSrc !== null &&
          <div className="picker-submitter-container">
            <div className="picture-box">
              Chosen picture:
              <img alt="Selfie to be uploaded" src={displayImgSrc == null ? undefined : displayImgSrc} style={{ display: (displayImgSrc == null ? "none" : "block") }} />
            </div>
            <div className="picker-submitter-buttons">
              <button onClick={() => {setDisplayImgSrc(null); setErrorMsg("")}}>Choose a different picture</button>
              {!isFilterApplied ?
                <input type="submit" value="Submit for matching" disabled={isUploadInFlight} />
                :
              <button className="revert-filter-btn" onClick={clearAll}>View all photos</button>
              }

              {!isFilterApplied && errorMsg !== "" && <div className="error-msg">{errorMsg}</div>}
              {isFilterApplied && resultMsg && <p className='filter-confirmation'>{resultMsg}</p>}
            </div>
          </div>
        }
      </div>
    </form>
  );
}